export default {
  meta: {
    title: '积分充值'
  }
};
